import deleteFile from './deleteFile'
import filesByClient from './filesByClient'
import uploadBatch from './uploadBatch'

export const deleteFileService = deleteFile
export const filesByClientService = filesByClient
export const uploadBatchService = uploadBatch
